<template>
  <FormDialog
    :visible="visible"
    title="修改密码"
    :width="560"
    @close="close"
  >
    <el-form
      ref="updatePwdForm"
      :model="pwdForm"
      :rules="pwdFormRules"
      label-width="100px"
      label-position="right"
      @submit.native.prevent
    >
      <el-form-item label="登录账户" prop="userCode">
        <el-input v-model="pwdForm.userCode" disabled />
      </el-form-item>
      <el-form-item label="原密码" prop="originalPassword">
        <el-input
          v-model="pwdForm.originalPassword"
          placeholder="请输入原密码"
          show-password
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="pwdForm.newPassword"
          placeholder="请输入新密码"
          show-password
          autocomplete="off"
        />
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button
        class="indiv-btn"
        type="primary"
        size="small"
        :loading="submitting"
        @click="submit"
      >
        提交
      </el-button>
    </template>
  </FormDialog>
</template>

<script>
/**
 * CTP 直连账户修改密码弹窗
 * POST /cloud/eval_jees/direct_updatePassword
 */

function emptyPwdForm() {
  return {
    userCode: "",
    originalPassword: "",
    newPassword: "",
  };
}

export default {
  name: "CtpDirectUpdatePassword",
  data() {
    return {
      visible: false,
      accountId: null,
      submitting: false,
      pwdForm: emptyPwdForm(),
    };
  },
  computed: {
    pwdFormRules() {
      return {
        originalPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem("token") || "{}");
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    clearFormValidate() {
      this.$nextTick(() => {
        const form = this.$refs.updatePwdForm;
        if (form) form.clearValidate();
      });
    },
    resetForm() {
      this.accountId = null;
      this.submitting = false;
      this.pwdForm = emptyPwdForm();
      this.clearFormValidate();
    },
    open(row) {
      if (!row || row.id == null || row.id === "") {
        return;
      }
      this.accountId = row.id;
      this.pwdForm = {
        ...emptyPwdForm(),
        userCode: row.userCode || "",
      };
      this.visible = true;
      this.clearFormValidate();
    },
    close() {
      this.visible = false;
      this.resetForm();
    },
    submit() {
      const form = this.$refs.updatePwdForm;
      if (!form || this.submitting) {
        return;
      }
      form.validate((valid) => {
        if (!valid) {
          return;
        }
        const original = String(this.pwdForm.originalPassword || "").trim();
        const newer = String(this.pwdForm.newPassword || "").trim();
        this.submitting = true;
        this.$axios
          .post("/cloud/eval_jees/direct_updatePassword", {
            id: this.accountId,
            apiToken: this.apiToken(),
            originalPassword: original,
            newPassword: newer,
          })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data && res.data.code == 200) {
              this.close();
              this.$emit("success");
              this.$alert(
                (res.data && (res.data.message || res.data.msg)) || "修改成功",
                {
                  confirmButtonText: "确定",
                  type: "success",
                  center: true,
                }
              );
            } else {
              this.$alert(
                (res.data && (res.data.message || res.data.msg)) || "操作失败",
                {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                }
              );
            }
          })
          .catch(() => {
            this.$alert("网络异常，请稍后重试", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            });
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/user/eval_jees/ctp_direct/CtpDirectUpdatePassword.vue